




























































import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoAlert from '@/components/Molecules/co-alert/CoAlert.vue';
import ensureStripePricingTableScript from '@/utils/stripePricingTable';

export default {
    name: 'SaaSBase',
    components: {
        CoText,
        CoAlert,
    },
    created() {
        this.addCoappScripts();
    },
    computed: {
        // Check if localStorage is enabled
        localStorageEnabled() {
            if (!this.$isLocalStorage) {
                return false; // localStorage check not performed yet
            }
            return this.$isLocalStorage;
        },
    },
    methods: {
        addCoappScripts() {
            ensureStripePricingTableScript();

            // matomo tracking
            const dynamicScript4 = document.createElement('script');
            dynamicScript4.setAttribute('src', '/static/scripts/matomo.js');
            dynamicScript4.async = true;
            document.head.appendChild(dynamicScript4);
        },
    },
};
